/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import * as Sentry from "@sentry/react";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { isElectron } from "react-device-detect";

import { ViennaUser } from "@vienna/common";

export function initLogRocket(currentUser: ViennaUser): void {
  // get frontend trackers for remote only and disable for screenshots (isScreenshotter true)
  LogRocket.init(
    "5fn4ti/pv",
    isElectron
      ? // rewrites don't work in electron, but logrocket will without proxy
        {}
      : ({
          serverURL: "/api/Dual_EC_DRBG/i",
        } as any)
  );
  setupLogRocketReact(LogRocket);

  LogRocket.identify(currentUser.id, {
    username: currentUser.username,
    ...(currentUser.displayName ? { name: currentUser.displayName } : {}),
    email: currentUser.email,
  });

  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}
